import "@/components/skeleton/dashboard-skeleton.css";

/** A single shimmer bar (mirrors the shared skeleton primitive). */
function Bar({ w, h = 12, r = 6, style }: { w: number | string; h?: number; r?: number; style?: React.CSSProperties }) {
  return <span className="sk" style={{ width: w, height: h, borderRadius: r, ...style }} />;
}

/**
 * Dedicated loader for the By-Clinician ETA table — kept separate from
 * `DashboardMetricsSkeleton` so this lazy section shimmers on its own. Doubles as
 * the Suspense fallback while its (lazy) chunk downloads.
 */
export default function ClinicianDetailsTableSkeleton({ cols = 7, rows = 8 }: { cols?: number; rows?: number }) {
  const colArr = Array.from({ length: cols });
  const rowArr = Array.from({ length: rows });
  return (
    <div className="pp-card" style={{ padding: 0, overflow: "visible", marginTop: 16 }} aria-hidden="true">
      <div className="tbl-toolbar">
        <Bar w={150} h={13} />
        <Bar w={180} h={30} r={8} style={{ marginLeft: 10 }} />
      </div>
      <div style={{ overflowX: "auto" }}>
        <table className="clintbl">
          <thead>
            <tr>
              {colArr.map((_, i) => (
                <th key={i}><Bar w={i === 0 ? 120 : 72} h={11} /></th>
              ))}
            </tr>
          </thead>
          <tbody>
            {rowArr.map((_, r) => (
              <tr key={r}>
                {colArr.map((_, c) => (
                  <td key={c}><Bar w={c === 0 ? 130 : 56} h={11} /></td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
